package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RoleResponse(
    val id: Int? = null,
    @SerialName("role_name")
    val roleName: String? = null
)
